"use client";

import type React from "react";
import {
  AgentSwapToolFields,
  defaultAgentSwapValues,
  type AgentSwapFormValues,
} from "./AgentSwapToolFields.tsx";

interface AgentSwapInlineBlockProps {
  tool: Record<string, unknown>;
  toolIndex: number;
  excludeAgentId?: string;
  handleUpdateTool: (index: number, field: string, value: unknown) => void;
  inputProps: Record<string, unknown>;
  labelColor: string;
  helperMuted: string;
  subtleBorder: string;
  subtleBg: string;
}

export const AgentSwapInlineBlock: React.FC<AgentSwapInlineBlockProps> = ({
  tool,
  toolIndex,
  excludeAgentId,
  handleUpdateTool,
  inputProps,
  labelColor,
  helperMuted,
  subtleBorder,
  subtleBg,
}) => {
  const base = defaultAgentSwapValues();
  const value: AgentSwapFormValues = {
    ...base,
    name: (tool.name as string) ?? base.name,
    description: (tool.description as string) ?? "",
    agent_id: (tool.agent_id as string) ?? "",
    keep_current_voice: !!tool.keep_current_voice,
    keep_current_language: !!tool.keep_current_language,
    post_call_analysis_setting:
      (tool.post_call_analysis_setting as AgentSwapFormValues["post_call_analysis_setting"]) ??
      base.post_call_analysis_setting,
    webhook_setting:
      (tool.webhook_setting as AgentSwapFormValues["webhook_setting"]) ??
      base.webhook_setting,
    speak_during_execution: !!tool.speak_during_execution,
    execution_message_type:
      (tool.execution_message_type as "prompt" | "static_text") ??
      base.execution_message_type,
    execution_message_description:
      (tool.execution_message_description as string) ?? "",
  };

  const onChange = (patch: Partial<AgentSwapFormValues>) => {
    (Object.keys(patch) as (keyof AgentSwapFormValues)[]).forEach((key) => {
      const v = patch[key];
      if (v !== undefined) {
        handleUpdateTool(toolIndex, key, v);
      }
    });
  };

  return (
    <AgentSwapToolFields
      value={value}
      onChange={onChange}
      excludeAgentId={excludeAgentId}
      inputProps={inputProps}
      labelColor={labelColor}
      helperMuted={helperMuted}
      subtleBorder={subtleBorder}
      subtleBg={subtleBg}
      showIntro={false}
      hideIdentityFields
    />
  );
};
